import { Link } from "react-router-dom";
import type { ChiguaArticle } from "../../mocks/chigua";
import { channelName } from "../../mocks/chigua";

function Meta({ article, dark = false }: { article: ChiguaArticle; dark?: boolean }) {
  return (
    <div
      className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-xs ${
        dark ? "text-foreground-100/80" : "text-foreground-500"
      }`}
    >
      <span className="flex items-center gap-1"><i className="ri-time-line" />{article.time}</span>
      <span className="flex items-center gap-1"><i className="ri-eye-line" />{article.views}</span>
      <span className="flex items-center gap-1"><i className="ri-chat-3-line" />{article.comments}</span>
    </div>
  );
}

/** layout="card": 顶部大图；layout="row": 左侧缩略图 */
export default function ArticleCard({
  article,
  layout = "card",
  dark = false,
}: {
  article: ChiguaArticle;
  layout?: "card" | "row";
  dark?: boolean;
}) {
  const link = `/baoliao/${article.id}`;
  const channelNameTag = channelName(article.channel);

  if (layout === "row") {
    return (
      <article className="group flex gap-4 overflow-hidden rounded-xl border border-background-200 bg-background-50 p-2.5 transition hover:border-primary-200">
        <Link to={link} className="relative block h-24 w-32 shrink-0 overflow-hidden rounded-lg sm:h-28 sm:w-44">
          <img src={article.image} alt={article.title} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
        </Link>
        <div className="flex min-w-0 flex-1 flex-col justify-center py-1 pr-1">
          <div className="mb-1.5 flex items-center gap-2">
            <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">{channelNameTag}</span>
            {article.hot && <span className="flex items-center gap-0.5 text-[11px] font-medium text-primary-600"><i className="ri-fire-fill" />热</span>}
          </div>
          <h3 className="line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 md:text-[15px]">
            <Link to={link} className="hover:text-primary-600">{article.title}</Link>
          </h3>
          <div className="mt-2"><Meta article={article} dark={dark} /></div>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition hover:-translate-y-0.5 hover:border-primary-200 hover:shadow-sm">
      <Link to={link} className="relative block overflow-hidden">
        <div className="relative aspect-[16/10] overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/35 to-transparent" />
          <span className="absolute left-3 top-3 rounded-md bg-background-50/95 px-2 py-1 text-[11px] font-semibold text-primary-700">
            {channelNameTag}
          </span>
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950">
          <Link to={link} className="hover:text-primary-600">{article.title}</Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-[13px] leading-relaxed text-foreground-600">{article.summary}</p>
        <div className="mt-auto flex items-center justify-between pt-3">
          <Meta article={article} dark={dark} />
          {article.hot && (
            <span className="flex items-center gap-1 text-xs font-medium text-primary-600">
              <i className="ri-flashlight-fill" aria-hidden="true" />
              正在发酵
            </span>
          )}
        </div>
      </div>
    </article>
  );
}